<template>
    <div class="tab-header">
        <md-tabs md-alignment="left" @md-changed="onTabChange($event)" :md-active-tab="activeTab" ref="tabs"
            class="md-tab-content-page">
            <md-tab to="/invoices/invoices_list" v-if="hasAccess('PRIVILEGE_INVOICE_LIST_ALL') || hasAccess('PRIVILEGE_INVOICE_LIST_MY')" id="tab-order-list" :md-label="$t('views.invoices.label.invoicesList')">
                <InvoicesList v-if="activeTab === 'tab-order-list'" :show-tab="false" :is-archive="false" @isContent="content = $event"
                @setDataModel="filterDataModel = $event" :filter-value-prop="filterValue" @addInvoicesIds="addInvoicesIds" />
            </md-tab>
            <md-tab to="/invoices/invoices_extraordinary_list" v-if="hasAccess('PRIVILEGE_INVOICE_EXTRAORDINARY')" id="tab-invoices-list" :md-label="$t('views.invoices.label.invoicesExtraordinaryList')">
                <InvoicesExtraordinaryList v-if="activeTab === 'tab-invoices-list'" @isContent="content = $event" 
                 @setDataModel="filterDataModel = $event" :filter-value-prop="filterValue" @addArchiveInvoicesIds="addArchiveInvoicesIds" />
            </md-tab>
        </md-tabs>
        <div class="md-flex-right-align">
        <div class="md-search-btn" v-if="!searchExpand" @click="searchExpand = !searchExpand">
            <md-icon>search</md-icon>
        </div>
        <adsign-filter v-if="searchExpand" v-model="filterValue" :filter-data-model="filterDataModel" class=""
            @search="searchTemplate()" />
            <div class="zipButton">
                <div v-show="!isReadyToDownloadZip && !loading">
                    <md-button class="md-header-btn md-header-tab-btn" :disabled="ids.length == 0" @click="saveZip()">{{ $t('views.invoices.zip.saveZip') }}</md-button>
                </div>
                <div v-show="isReadyToDownloadZip && !loading">
                    <md-button class="md-header-btn md-header-tab-btn" :disabled="ids.length == 0" @click="downloadZip()">{{ $t('views.invoices.zip.downloadZip') }}</md-button>
                </div>
                <div v-show="loading">
                    <md-progress-spinner :md-diameter="50" :md-stroke="3" class="md-accent"
                        md-mode="indeterminate" />
                </div>
            </div>
            <div>
                <md-button class="md-header-btn md-header-tab-btn" :disabled="isContentTable()" @click="downloadExcel()">{{ $t('views.invoices.saveExcel') }}</md-button>
            </div>
        </div>
    </div>
</template>

<script>
    import InvoicesList from "@/views/invoices/list/InvoicesList";
    import {invoicesEndpoint, archivesEndpoint} from '@/services/adsign-backend/endpoints'
    import InvoicesExtraordinaryList from "@/views/invoices/list/InvoicesExtraordinaryList"
    import {mapGetters} from "vuex";
    import ExcelDownloader from '@/utils/exelDownloader-utils'
    import AdsignFilter from '@/components/AdsignFilter';
    import {FilterType} from '@/mixins/filterType';
    import store from "@/store";

    export default {
        name: "Invoices",
        components: {InvoicesExtraordinaryList, InvoicesList, AdsignFilter},
        computed: {
            ...mapGetters('auth', ['hasAccess']),
            ...mapGetters("misc", ["searcherFilterData"]),
        },
        data: () => {
            return {
                activeTab: undefined,
                content: null,
                searchExpand: false,
                filterValue: '',
                filterDataModel: [],
                ids: [],
                isReadyToDownloadZip: false,
                loading: false
            }
        },
        mounted() {
            const tabs = Object.entries(this.$refs.tabs.MdTabs.items);
            const currentTab = tabs
                .map(item => ({
                    id: item[0],
                    ...item[1]
                }))
                .find(tab => this.$route.path.endsWith(tab.props.to));

            if (currentTab) {
                this.activeTab = currentTab.id;
            }
            this.$watch(() => this.searcherFilterData, (result) => {
                this.filterValue = result.filter
                this.searchExpand = result.searchExpand
            })
        },
        methods: {
            onTabChange(tabId) {
                if (tabId) {
                    this.activeTab = tabId;
                    this.ids = [];
                    store.commit('misc/SEARCHER_DATA', {
                        filter: '',
                        inputData: '',
                        searchExpand: false
                    })
                }
            },
            downloadExcel(){
                let table
                table = new ExcelDownloader(document.querySelector('table'))
                table.exportXLS("Archiwum_"+this.activeTab)
            },
            isContentTable(){
                if(!this.content){
                    return true
                }
                return false
            },
            searchTemplate() {
                return this.filterValue;
            },
            addInvoicesIds(invoicesIds) {
                if(this.activeTab === 'tab-order-list') {
                    this.ids = invoicesIds;
                    this.loading = false;
                    this.isReadyToDownloadZip = false;
                }
            },
            addArchiveInvoicesIds(archiveInvoicesIds) {
                if(this.activeTab === 'tab-invoices-list') {
                    this.ids = archiveInvoicesIds;
                    this.loading = false;
                    this.isReadyToDownloadZip = false;
                }
            },
            saveZip() {
                this.loading = true;
                const isArchive = this.activeTab === 'tab-invoices-list';
                if (isArchive) {
                    archivesEndpoint.saveZipInvoices(this.ids)
                        .then( result => {
                            this.loading = false;
                            this.isReadyToDownloadZip = true;
                        })
                } else {
                    invoicesEndpoint.saveZipInvoices(this.ids)
                        .then( result => {
                            this.loading = false;
                            this.isReadyToDownloadZip = true;
                        })
                }
            },
            downloadZip() {
                this.loading = true;
                const isArchive = this.activeTab === 'tab-invoices-list';

                if (isArchive) {
                    archivesEndpoint.getZipInvoices(this.ids)
                        .then( result => {
                            let blob = new Blob([result], { responseType: 'blob' })
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'Compressed_Invoices.zip');
                            document.body.appendChild(link);
                            link.click();
                            this.loading = false;
                        })
                } else {
                    invoicesEndpoint.getZipInvoices(this.ids)
                        .then( result => {
                            let blob = new Blob([result], { responseType: 'blob' })
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'Compressed_Invoices.zip');
                            document.body.appendChild(link);
                            link.click();
                            this.loading = false;
                        })
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .tab-header {
        display: flex;
    }
    .orderPreviewBar{
        margin-top: 15px;
    }
    .zipButton {
        margin-right: 15px;
    }
    .custom-nav-button-style {
        height: 40px;
        position: absolute;
        right: 72px;
        top: 115px;
    }
    ::v-deep{
        .md-header-btn:disabled{
            background: rgb(200, 200, 200);
            box-shadow: none;
            color: rgb(120, 120, 120) !important
        }
    }
</style>
